import { TemplateStore } from './template.store';
import { Injectable } from '@angular/core';
import { BaseQuery } from "../base/base.query";

@Injectable({ providedIn: 'root' })
export class TemplateQuery extends BaseQuery {

    constructor(store: TemplateStore) {
        super(store);
    }
}
